import React from 'react';

import Button from 'components/form/Button.component';

import DropdownMenuFooter from 'clientCommunications/components/Clients/common/DropdownMenuFooter.component';

const NextVisitDropDown = ({
  isNextVisit,
  selectedNextVisit,
  onCheckNextVisit,
  onDoneNextVisit,
  onClearNextVisitSelection,
}) => (
  <div className={`drop-down dd-next-visit ${isNextVisit ? '' : 'hidden'}`}>
    <div className="main">
      <span className="span-header">Only show clients who have</span>
      <ul>
        <li key={1} className="dropdown-item">
          <label className="clickable-label">
            <span>An appointment on any date in future</span>
            <div className="checkbox-box-custom-wrap dd-chk">
              <input
                type="checkbox"
                className="radio-custom"
                id="next-check-1"
                checked={selectedNextVisit === 'anyDate'}
                onChange={() => {
                  onCheckNextVisit('anyDate');
                }}
              />
              <label className="checkbox-box-label" htmlFor="next-check-1">
                <div className={`rbt-custom-icon ${selectedNextVisit === 'anyDate' ? '' : 'hidden'}`}>
                  <span className="ic-sml ic_dot_white_18" />
                </div>
              </label>
            </div>
          </label>
        </li>
        <li key={2} className="dropdown-item">
          <label className="clickable-label">
            <span>An appointment in the next 7 days</span>
            <div className="checkbox-box-custom-wrap dd-chk">
              <input
                type="checkbox"
                className="radio-custom"
                id="next-check-2"
                checked={selectedNextVisit === 'next7days'}
                onChange={() => {
                  onCheckNextVisit('next7days');
                }}
              />
              <label className="checkbox-box-label" htmlFor="next-check-2">
                <div className={`rbt-custom-icon ${selectedNextVisit === 'next7days' ? '' : 'hidden'}`}>
                  <span className="ic-sml ic_dot_white_18" />
                </div>
              </label>
            </div>
          </label>
        </li>
        <li key={3} className="dropdown-item">
          <label className="clickable-label">
            <span>Not got a future appointment</span>
            <div className="checkbox-box-custom-wrap dd-chk">
              <input
                type="checkbox"
                className="radio-custom"
                id="next-check-3"
                checked={selectedNextVisit === 'noFuture'}
                onChange={() => {
                  onCheckNextVisit('noFuture');
                }}
              />
              <label className="checkbox-box-label" htmlFor="next-check-3">
                <div className={`rbt-custom-icon ${selectedNextVisit === 'noFuture' ? '' : 'hidden'}`}>
                  <span className="ic-sml ic_dot_white_18" />
                </div>
              </label>
            </div>
          </label>
        </li>
      </ul>

      <DropdownMenuFooter>
        <Button variant="slim" onClick={onClearNextVisitSelection}>
          CLEAR
        </Button>
        <Button variant="slim" onClick={onDoneNextVisit}>
          DONE
        </Button>
      </DropdownMenuFooter>
    </div>
  </div>
);

export default NextVisitDropDown;
